var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"me-avatar"},[(_vm.isImage)?_c('img',{attrs:{"src":_vm.image,"alt":_vm.name}}):_c('span',[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }